export const DEFAULT_OPACITY = 1;
export const OPACITY_FREE = 0;
export const OPACITY_TENTATIVE = 0.08;
export const OPACITY_BUSY = 0.24;
export const OPACITY_INCREMENT = 0.1;

export const BORDER_OPACITY = 0.6;

export const MINIMUM_TEXT_CONTRAST_REST = 6.0;
export const MINIMUM_TEXT_CONTRAST_SELECTED = 4.5;
